import { render, staticRenderFns } from "./TheMainMenu.vue?vue&type=template&id=95866d58&"
import script from "./TheMainMenu.vue?vue&type=script&lang=ts&"
export * from "./TheMainMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports